export default __webpack_public_path__ + "static/media/tokenImageSimer.5d31465f.svg";